'use client';

import {IQButton} from '@repo/ui/iq-button';
import {FRONTEND_URL} from 'config';
import {trackPracticeWithAIClicked} from 'iq-interview_guides/tracking';

interface PracticeWithAICtaProps {
  guideSlug: string;
  className?: string;
}

// Deep link into the AI mock interview setup page, preselecting this guide.
export function PracticeWithAICta({guideSlug, className}: PracticeWithAICtaProps) {
  const href = `${FRONTEND_URL}/ai-mock-interview?guide=${encodeURIComponent(guideSlug)}`;
  return (
    // The click bubbles up from the anchor rendered by IQButton, which doesn't forward onClick.
    <div className={className} onClick={() => void trackPracticeWithAIClicked(guideSlug)}>
      <IQButton href={href} size='lg' color='orange' rounded className='px-5 font-semibold'>
        Practice this interview with AI
      </IQButton>
    </div>
  );
}
